module.exports = __webpack_public_path__ + "img/0-sm.0c7c9895.jpg";